import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  Form,
  Container,
  Row,
  Col,
} from "react-bootstrap";
import { AppCard } from "../../component/AppCard";
import { AppLabel } from "../../component/AppLabel";
import AppButton from "../../component/AppButton/AppButton";
import useGetData from "../../hooks/useGetData";
import { AppCheckBox, AppInputGroup } from "@dcam/dcam_flhealth_component_library";
import * as Yup from "yup";
import { RoleData } from "../Dashboard/Dashboard.types";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/pro-solid-svg-icons";
import AppDataTable from "../../component/AppDataTable/AppDataTable";
import { useDownloadFile } from "../../hooks/useDownloadFile";

interface LocationModalProps {
  show: boolean;
  hospitalId?: string;
  onHide: () => void;
  onSave: (data: any) => void;
  data?: any;
}


interface SelectOption {
  id: string;
  value: string;
}
const UserModal: React.FC<LocationModalProps> = ({ show, hospitalId, onHide, onSave, data }) => {
  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  const [userFirstName, setUserFirstName] = useState<string>("");
  const [userLastName, setUserLastName] = useState<string>("");
  const [userAddress, setUserAddress] = useState<string>("");
  const [userCity, setUserCity] = useState<string>("");
  const [userZipcode, setUserZipcode] = useState<string>("");
  const [userPhone, setUserPhone] = useState<string>("");
  const [userRole, setUserRole] = useState<string>("");
  const [userIsActive, setUserIsActive] = useState<boolean>(false);
  const [userEmail, setUserEmail] = useState<string>("");
  const [userNotes, setUserNotes] = useState<string>("");
  const [routinizedFacility, setRoutinizedFacility] = useState<string>("");
  const [routinizedHospital, setRoutinizedHospital] = useState<string>(hospitalId || "");
  const [userDataAgreementFile, setUserDataAgreementFile] = useState<File | null>(null);
  const [ssnPolicyFile, setSsnPolicyFile] = useState<File | null>(null);


  const [states, setStates] = useState<SelectOption[]>([]);
  const [counties, setCounties] = useState<SelectOption[]>([]);
  const [fieldsEnabled, setFieldsEnabled] = useState(false);
  const { downloadFile } = useDownloadFile();
  const token = sessionStorage.getItem("accessToken");


  const { getDataById: getCounties } = useGetData<SelectOption[], string>(
    "Client/Counties",
    "GET"
  );
  const { getDataById: getStates } = useGetData<SelectOption[], string>(
    "Client/States",
    "GET"
  );

  const [allRolesData, setAllRolesData] = useState<SelectOption[]>([]);
  const { getDataById: getRoles } = useGetData<SelectOption[], string>(
    "Client/Roles",
    "GET"
  );

  const [allRoutinizedHospitalsData, setallRoutinizedHospitalsData] = useState<
    SelectOption[]
  >([]);

  const { getDataById: getRoutinizedHospitals } = useGetData<
    SelectOption[], string>(
      "Client/RoutinizedHospitals", "GET");

  const { getDataById: getRoutinizedFacilities } = useGetData<
    SelectOption[], string>("Client/RoutinizedFacilities", "GET");

  const [filteredRoutinizedFacilities, setFilteredRoutinizedFacilities] =
    useState<any[]>([]);

  const handleUserDataAgreementFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setUserDataAgreementFile(e.target.files[0]);
    }
  };

  const handleSsnPolicyFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setSsnPolicyFile(e.target.files[0]);
    }
  };
  const userFiles = data?.files || null;


  useEffect(() => {
    console.log(data);
    if (data) {
      setUserEmail(data.email || "");
      setUserFirstName(data.firstName || "");
      setUserLastName(data.lastName || "");
      setUserAddress(data.streetAddress || "");
      setUserCity(data.city || "");
      setUserZipcode(data.zipCode || "");
      setUserPhone(data.workPhone);
      setUserRole(data.roleId || "0");
      setUserIsActive(data.isActive || false);
      setUserNotes(data.notes || "");
      setRoutinizedFacility(data.routinizedFacilityId || "0");
      setRoutinizedHospital(data.routinizedHospital || hospitalId || "");
      setFieldsEnabled(true)
    } else {
      setFieldsEnabled(false);
      setUserIsActive(true);
    }

    const fetchStatesAndCounties = async () => {
      const stateData = await getStates("");
      const countyData = await getCounties("");
      setStates(stateData || []);
      setCounties(countyData || []);
    };

    fetchStatesAndCounties();


    const fetchRoles = async () => {
      try {
        const data = await getRoles("");
        if (data) {
          var filter = data.filter(x => x.id.toString() !== "1")
          setAllRolesData(filter);
        }
      } catch (error) {
        console.error("Failed to fetch roles", error);
      }
    };

    fetchRoles();

    const fetchRoutinizedHospitals = async () => {
      try {
        const data = await getRoutinizedHospitals("");
        if (data) {

          setallRoutinizedHospitalsData(data);
        }
      } catch (error) {
        console.error("Failed to fetch roles", error);
      }
    };

    fetchRoutinizedHospitals();

    const fetchRoutinizedFacility = async () => {
      const facilityData = await getRoutinizedFacilities(
        `${hospitalId}`
      );

      if (facilityData) {
        setFilteredRoutinizedFacilities(facilityData);
      }
    };
    fetchRoutinizedFacility();
  }, [data]);

  const handleSave = () => {
    if (!validateFields()) return;

    onSave({
      userFirstName,
      userLastName,
      userAddress,
      userCity,
      userZipcode,
      userPhone,
      userRole,
      userIsActive,
      userEmail,
      userNotes,
      routinizedFacility,
      routinizedHospital,
      userDataAgreementFile,
      ssnPolicyFile
    });

    onHide();
  };

  const handleClearFields = () => {
    setEmailError("");
    setUserEmail("");
    setUserFirstName("");
    setUserLastName("");
    setUserAddress("");
    setUserCity("");
    setUserZipcode("");
    setUserPhone("");
    setUserRole("");
    setUserIsActive(false);
    setRoutinizedFacility("");
    setUserNotes("");
  };

  const handleHide = () => {
    handleClearFields();
    onHide();
  };

  const validateFields = () => {
    let tempErrors: { [key: string]: string } = {};
    if (!userFirstName.trim()) tempErrors.userFirstName = "First Name is required.";
    if (!userLastName.trim()) tempErrors.userLastName = "Last Name is required.";
    if (!userRole) tempErrors.userRole = "Role is required.";
    if (!routinizedFacility) tempErrors.routinizedFacility = "Facility/Location is required.";
    //  if (!userAddress.trim()) tempErrors.userAddress = "Address is required.";
    // if (!userCity.trim()) tempErrors.userCity = "City is required.";
    // if (!userZipcode.trim()) tempErrors.userZipcode = "Zip Code is required.";

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const onHospitalChange = async (e: any) => {
    setRoutinizedHospital(e.target.value);
    const facilityData = await getRoutinizedFacilities(
      `${e.target.value}`
    );

    if (facilityData) {
      setFilteredRoutinizedFacilities(facilityData);
    }



  };

  const [emailError, setEmailError] = useState("");
  const [emailErrorColor, setEmailErrorColor] = useState("");
  const { getDataById: checkEmailExist } = useGetData(
    `UserSecurity/CheckUserByEmail`,
    "GET"
  );

  const handleValidateEmail = async () => {

    try {
      const data = await checkEmailExist(userEmail);

      if (data === true) {
        setEmailError(
          "Email already exists cannot be used, try another email."
        );
        toast.error("Email already exists cannot be used, try another email.", {
          position: "top-right",
          autoClose: 2000,
        });
        setEmailErrorColor("red");
        setFieldsEnabled(false);
      } else if (data === false) {
        setEmailError("Email Address can be used!");
        toast.success("Email Address can be used!", {
          position: "top-right",
          autoClose: 2000,
        });
        setEmailErrorColor("green");
        setFieldsEnabled(true);
      } else {
        setFieldsEnabled(false);
      }
    } catch (error) {
      console.error("API call failed", error);
    }
  };

  const handleDownload = (fileId: { toString: () => any; }, fileName: any) => async (event: { preventDefault: () => void; }) => {
    event.preventDefault();
    if (token && fileId && fileName) {
      await downloadFile({
        documentId: fileId.toString(),
        token: token,
        documentName: fileName,
      });
    }
  };


  const fileColumns = [
    {
      name: "Files",
      selector: (row: any) => (
        <div className="d-flex align-items-center">
          <span>{row.fileName}</span>
          <a
            href={row.filePath}
            download
            style={{ marginLeft: "10px", textDecoration: "none" }}
            title={`Download ${row.fileName}`}
            onClick={handleDownload(row.fileId, row.fileName)}
          >
            <FontAwesomeIcon icon={faDownload} />
          </a>
        </div>
      ),
      sortable: true,
    },
  ];


  return (
    <Modal show={show} onHide={handleHide} centered className="modal-lg">
      <Modal.Header closeButton>
        <Modal.Title>User Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <AppCard>
            <Row className="mb-4">
              <Col sm={6}>
                <AppLabel label="Email" required></AppLabel>
                <Form.Control
                  type="text"
                  value={userEmail}
                  onChange={(e) => setUserEmail(e.target.value)}
                  placeholder="Enter Email"
                  isInvalid={!!errors.userEmail}
                  disabled={data?.userId > 0}
                />

                {emailError && (
                  <span style={{ color: emailErrorColor }}>{emailError}</span>
                )}
              </Col>
              <Col sm={6} style={{ padding: '20px' }}>
                <AppButton variant="primary" onClick={handleValidateEmail} type="button" disabled={data?.userId > 0} >Check</AppButton>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col>
                <AppLabel label="First Name" required />
                <Form.Control
                  type="text"
                  value={userFirstName}
                  onChange={(e) => setUserFirstName(e.target.value)}
                  placeholder="Enter First Name"
                  isInvalid={!!errors.userFirstName}
                  disabled={!fieldsEnabled}
                />
                <Form.Control.Feedback type="invalid">{errors.userFirstName}</Form.Control.Feedback>
              </Col>
              <Col>
                <AppLabel label="Last Name" required />
                <Form.Control
                  type="text"
                  value={userLastName}
                  onChange={(e) => setUserLastName(e.target.value)}
                  placeholder="Enter Last Name"
                  isInvalid={!!errors.userLastName}
                  disabled={!fieldsEnabled}
                />
                <Form.Control.Feedback type="invalid">{errors.userLastName}</Form.Control.Feedback>
              </Col>
            </Row>

            <Row className="mb-4">
              <Col>
                <AppLabel label="Address" />
                <Form.Control as="textarea"
                  rows={2}
                  value={userAddress}
                  onChange={(e) => setUserAddress(e.target.value)}
                  placeholder="Enter Address"
                  // isInvalid={!!errors.userAddress}
                  disabled={!fieldsEnabled}
                />
                {/* <Form.Control.Feedback type="invalid">{errors.userAddress}</Form.Control.Feedback> */}
              </Col>
              <Col>
                <AppLabel label="City" />
                <Form.Control
                  type="text"
                  value={userCity}
                  onChange={(e) => setUserCity(e.target.value)}
                  placeholder="Enter City"
                  // isInvalid={!!errors.userCity}
                  disabled={!fieldsEnabled}
                />
                {/* <Form.Control.Feedback type="invalid">{errors.userCity}</Form.Control.Feedback> */}
              </Col>
            </Row>

            <Row className="mb-4">
              <Col>
                <AppLabel label="Zip Code" />
                <Form.Control
                  type="text"
                  value={userZipcode}
                  onChange={(e) => setUserZipcode(e.target.value)}
                  placeholder="Enter Zip Code"
                  maxLength={5}
                  //   isInvalid={!!errors.userZipcode}
                  disabled={!fieldsEnabled}
                />
                {/* <Form.Control.Feedback type="invalid">{errors.userZipcode}</Form.Control.Feedback> */}
              </Col>
              <Col>
                <AppLabel label="Work Phone" />
                <Form.Control
                  type="text"
                  value={userPhone || ""}
                  onChange={(e) => setUserPhone(e.target.value)}
                  placeholder="Enter Work Phone Number"
                  disabled={!fieldsEnabled}
                />
              </Col>
            </Row>

            <Row className="mb-4">
              <Col>
                <AppLabel label="Select Role" />
                <Form.Select onChange={(e) => setUserRole((e.target.value))} disabled={!fieldsEnabled} value={userRole} isInvalid={!!errors.userRole}>
                  <option value={0}>Select Role</option>
                  {allRolesData.map((cnt) => (
                    <option key={cnt.id} value={Number(cnt.id)}>
                      {cnt.value}
                    </option>

                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">{errors.userRole}</Form.Control.Feedback>
              </Col>
              <Col style={{ padding: '35px' }}>
                <Form.Check
                  type="checkbox"
                  name="IsActiveUser"
                  label="Active"
                  checked={userIsActive}
                  onChange={(e) => setUserIsActive(e.target.checked)}
                  disabled={!fieldsEnabled}
                  style={{ color: '#000' }}
                />
              </Col>
            </Row>
            <Row className="mb-4">
              <Col>
                <AppLabel label="Routinized Testing Focus Project - Hospital" />
                <Form.Select disabled onChange={(e) => onHospitalChange(e)} value={routinizedHospital}
                //isInvalid={!!errors.userRole}
                >
                  <option value={0}>Select Hospital</option>
                  {allRoutinizedHospitalsData.map((cnt) => (
                    <option key={cnt.id} value={Number(cnt.id)}>
                      {cnt.value}
                    </option>
                  ))}
                </Form.Select>
              </Col>

              <Col>
                <AppLabel label="Routinized Testing Focus Project - Facility" />
                <Form.Select onChange={(e) => setRoutinizedFacility(e.target.value)} disabled={!fieldsEnabled} value={routinizedFacility} isInvalid={!!errors.routinizedFacility}>
                  <option value={0}>Select Facility</option>
                  {filteredRoutinizedFacilities.map((cnt) => (
                    <option key={cnt.id} value={Number(cnt.id)}>
                      {cnt.value}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">{errors.routinizedFacility}</Form.Control.Feedback>
              </Col>
            </Row>

            <Row className="mb-4">
              <Col>
                <AppLabel label="Notes"></AppLabel>
                <Form.Control
                  type="textarea"
                  as="textarea"
                  name="userNotes"
                  rows={5}
                  disabled={!fieldsEnabled}
                  value={userNotes}
                  onChange={(e) => setUserNotes(e.target.value)}
                />
              </Col>

              <Col>
                <Row>
                  {data == undefined ? (

                    <div className="col-12">
                      <div>
                        <AppLabel label="User Data Agreement Document" required></AppLabel>
                        <input
                          type="file"
                          name="userDataAgreementFile"
                          disabled={!fieldsEnabled}
                          onChange={handleUserDataAgreementFileChange}
                          className="form-control"
                        />
                      </div>
                      <div>
                        <AppLabel label="SSN Policy File" required></AppLabel>
                        <input
                          type="file"
                          name="ssnPolicyFile"
                          disabled={!fieldsEnabled}
                          onChange={handleSsnPolicyFileChange}
                          className="form-control"
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="col-12">
                      {data !== undefined && data?.userId > 0 && userFiles && userFiles.length > 0 ? (
                        <AppDataTable
                          //tableHeading="User Files"
                          data={userFiles}
                          columns={fileColumns}
                          pagination={false}
                          search={false}
                        />
                      ) : (
                        <p>No files available</p>
                      )}
                    </div>
                  )}
                </Row>
              </Col>
            </Row>
          </AppCard>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <AppButton variant="secondary" onClick={handleHide}>Cancel</AppButton>
        <AppButton variant="primary" type="button" onClick={handleSave}>Save</AppButton>
      </Modal.Footer>
    </Modal>
  );
};

export default UserModal;
